/**
 * Custom Variant Picker Enhancements
 *
 * Extends Dawn's VariantSelects component with:
 * - Hover preview of variant names on desktop
 * - Support for custom var_selector_preview metafield
 *
 * @requires global.js (VariantSelects class)
 */

if (!customElements.get('variant-selects')) {
  console.error('custom-variant-picker.js: VariantSelects not found. Ensure global.js loads first.');
} else {
  // Store original connectedCallback
  const OriginalVariantSelects = customElements.get('variant-selects');
  const originalConnectedCallback = OriginalVariantSelects.prototype.connectedCallback;

  // Extend the connectedCallback
  OriginalVariantSelects.prototype.connectedCallback = function () {
    // Call original functionality
    originalConnectedCallback.call(this);

    // Add hover preview for desktop (750px+)
    if (window.matchMedia('(min-width: 750px)').matches) {
      this.initializeHoverPreview();
    }
  };

  // Add hover preview method to the prototype
  OriginalVariantSelects.prototype.initializeHoverPreview = function () {
    const labels = this.querySelectorAll(
      '.product-form__input--pill label, .product-form__input--swatch .swatch-input__label',
    );

    labels.forEach((label) => {
      label.addEventListener('mouseenter', (event) => {
        const input = label.previousElementSibling || document.getElementById(label.getAttribute('for'));
        if (!input) return;

        const selectedValueSpan = input.closest('.product-form__input').querySelector('[data-selected-value]');
        if (!selectedValueSpan) return;

        // Store original value
        if (!selectedValueSpan.dataset.originalValue) {
          selectedValueSpan.dataset.originalValue = selectedValueSpan.textContent.trim();
        }

        // Show hovered value
        const value = input.value || label.querySelector('.visually-hidden')?.textContent.trim();
        if (value) {
          selectedValueSpan.textContent = value;
          selectedValueSpan.classList.add('is-previewing');
        }
      });

      label.addEventListener('mouseleave', (event) => {
        const input = label.previousElementSibling || document.getElementById(label.getAttribute('for'));
        if (!input) return;

        const selectedValueSpan = input.closest('.product-form__input').querySelector('[data-selected-value]');
        if (!selectedValueSpan || !selectedValueSpan.dataset.originalValue) return;

        // Restore original value
        selectedValueSpan.textContent = selectedValueSpan.dataset.originalValue;
        selectedValueSpan.classList.remove('is-previewing');
        delete selectedValueSpan.dataset.originalValue;
      });
    });
  };

  console.log('custom-variant-picker.js: Hover preview functionality initialized');
}
